module.exports = __webpack_public_path__ + "img/slide10.0db339c1.png";